import type { FormDefinition } from '@/core/templates/types'

export default {
  title: 'Maßnahme',
  sections: {
    Maßnahme: {
      fields: [
        { id: 'Maßnahme.Nummer', control: 'text-or-date' },
        { id: 'Maßnahme.Bezeichnung', control: 'text-or-date' },
      ],
    },
    Umfang: {
      fields: [
        { id: 'Umfang.UE-Anzahl', control: 'text-or-date' },
        { id: 'Umfang.Kosten', control: 'text-or-date' },
        { id: 'Umfang.Zeitlicher Umfang pro Woche', control: 'text-or-date' },
        { id: 'Umfang.Durchführungsort', control: 'select', options: ['online', 'offline'] },
        { id: 'Umfang.Durchführungsform', control: 'select', options: ['Einzel', 'Gruppe'] },
      ],
    },
    Zulassung: {
      fields: [
        { id: 'Zulassung.Beginn', control: 'date' },
        { id: 'Zulassung.Ende', control: 'date' },
      ],
    },
    Inhalte: {
      fields: [
        { id: 'Inhalte.Inhalt', control: 'text', dictation: true },
        { id: 'Inhalte.Ziele und Inhalte', control: 'text', dictation: true },
        { id: 'Inhalte.Abschluss', control: 'text-or-date' },
      ],
    },
    Ansprechpartner: {
      fields: [{ id: 'Ansprechpartner.Ansprechpartner', control: 'select', options: [] }],
    },
  },
} satisfies FormDefinition
